<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="xblock layui-form">
			<!-- <button class="layui-btn xblock-row" v-on:click="ImportOrder()">导入订单</button> -->
			<button class="layui-btn xblock-row" v-on:click="ShowModel()">发起募资</button>
			<div class="layui-input-inline xblock-row">
				<input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
			</div>
			<div class="layui-input-inline xblock-row">
				<input type="text" name="username" placeholder="募资ID查询" v-on:keydown.13="get_recharge_record()"
              v-model="batch_id" autocomplete="off" class="layui-input" />
			</div>
			<button class="layui-btn xblock-row" style="height: 36px;" lay-filter="sreach"
            v-on:click="get_recharge_record()"><i class="fa fa-search"></i></button>
			<div class="x-right xblock-row">
				<span class="x-right" v-text="'共有数据：'+count+ '条'"></span>
				<span class="x-right" v-text="'营业额：'+money+ '元　|　'"></span>
			</div>
			<div class="clear-both"></div>
        </div>

        <table class="layui-table layui-form">
          <thead>
            <tr>
              <th>编号</th>
              <th>站点</th>
              <th>订单编号</th>
              <th>数量</th>
              <th>订单金额</th>
              <th>营业额（CNY）</th>
              <th>买家名称</th>
              <th>时间</th>
            </tr>
          </thead>
          <tbody>
            <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
              <td v-text="item.number"></td>
              <td>
                <i v-if="item.country == 'TW'">台湾</i>
                <i v-else-if="item.country == 'PH'">菲律宾</i>
                <i v-else-if="item.country == 'VN'">越南</i>
                <i v-else-if="item.country == 'TH'">泰国</i>
                <i v-else-if="item.country == 'ID'">印尼</i>
                <i v-else-if="item.country == 'SG'">新加坡</i>
                <i v-else-if="item.country == 'BR'">巴西</i>
                <i v-else-if="item.country == 'MY'">马来西亚</i>
                <i v-else-if="item.country == 'MX'">墨西哥</i>
                <i v-else-if="item.country == 'CO'">哥伦比亚</i>
                <i v-else-if="item.country == 'CL'">智利</i>
                <i v-else-if="item.country == 'PL'">波兰</i>
                <i v-else-if="item.country == 'ES'">西班牙</i>
              </td>
              <td v-text="item.id"></td>
              <td v-text="item.order_datas.items.length"></td>
              <td>
                <i v-if="item.country == 'TW'" v-text="'NT'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'MY'" v-text="'RM'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'PH'" v-text="'₱'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'VN'" v-text="'₫'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'TH'" v-text="'฿'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'ID'" v-text="'Rp'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'SG'" v-text="'$'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'BR'" v-text="'R$'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'MX'" v-text="'MX$'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'CO'" v-text="'COP'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'CL'" v-text="'CLP'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'PL'" v-text="'zł'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'ES'" v-text="'€'+item.escrow_amount"></i>
                <i v-else-if="item.country == 'FR'" v-text="'€'+item.escrow_amount"></i>
              </td>
              <td v-text="item.total_money"></td>
              <td v-text="item.order_datas.buyer_username"></td>
              <td v-text="item.create_time"></td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition v-if="list.length < 1"></K-Transition>

      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>
  </div>
</template>

<script>
  var self, form, layer, laypage, laydate, modalbox;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'Order',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        money: 0,
        page_num: 20,
        current_status: 0,
        status_id: 0,
        batch_id:null,
        list: [],
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "未完成"
        }, {
          id: 2,
          name: "已完成"
        }]
      }
    },
    mounted() {
      self = this;

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {

        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        laydate = layui.laydate;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true,
          trigger: 'click',
          done: function(value, date, endDate) {
            $("#order_date").val(value);
            self.get_recharge_record()
          }
        });

        if(localStorage.getItem("ExShopee_batch_id")){
          self.batch_id = localStorage.getItem("ExShopee_batch_id");
          localStorage.removeItem("ExShopee_batch_id");
        }

        self.get_recharge_record()
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_recharge_record() {
        //获取的结束时间自动加一天
        var t = $("#order_date").val();
        var start_time, end_time;
        if (t) {
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })
        }

        self.loading = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        if (start_time) {
          param.append('start_time', start_time)
        }
        if (end_time) {
          param.append('end_time', end_time)
        }
        if (self.batch_id) {
          param.append('batch_id', self.batch_id)
        }

        param.append('status', self.status_id)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/admin_shopee_order_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            let country_amount = datas.country_amount;
            let list = datas.list;
            let y = 1;
            self.count = datas.page.count;
            for (let i in list) {
              list[i].number = y++;
              for (let x in country) {
                if (list[i].country == country[x].en_name) {
                  list[i].total_money = (list[i].escrow_amount / country[x].exchange).toFixed(2);
                }
              }
            }

            var money = 0;
            for (let x in country_amount) {
              money += country_amount[x].total_amount_all_exchange;
            }

            self.list = list;
            self.money = money.toFixed(2);
            self.ShowPage(self, laypage, "get_recharge_record"); //分页
            $('.pagebox').show();

            self.$nextTick(() => {
              form.render();
            });

          }, false);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      ShowModel(datas) {
        console.log($(window).width())
        var w;
        if (w == null || w == '') {
          w = $(window).width() - 260;
          if (w > 500) {
            w = 500;
          }
        };
        modalbox = layer.open({
          type: 1,
          offset: '100px',
          title: '发起募资',
          area: [w + 'px', '380px'],
          fixed: false, //不固定
          btn: ['确定'],
          content: ReleaseDemand,
          success: function() {

          },
          yes: function(index, layero) {
            self.release();
          }
        });
      },
      release() {
        var title = $("#title").val();
        var order_number = $("#order-number").val();
        var money = $("#money").val();
        var interest = $("#interest").val();
        if (!interest) {
          interest = 1.5;
        }
        if (!order_number) {
          self.ToastFun(2, "订单区间不能为空！"); //弹窗提醒
          return;
        } else {
          let order = order_number.split(' ');
          var first_code = order[0];
          var last_code = order[1];
          var oarr = JSON.stringify([first_code, last_code]);
        }

        self.loading = true;
        let param = new URLSearchParams()
        param.append('name', title);
        param.append('orders', oarr);
        param.append('total_money', money);
        param.append('interest_rate', interest);
        param.append('is_fixed', 1);
        param.append('fixed', 30);
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/financing_store/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            layer.close(modalbox);
            self.ToastFun(0, "操作成功！"); //弹窗提醒
          }, false);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      ImportOrder(){
        self.loading = true;
        axios({
          method: 'get',
          url: self.GetServerUrl() + "/import_order/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.ToastFun(0, "操作成功！"); //弹窗提醒
          }, false);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .xblock-row {
    margin-right: 5px;
  }

  .country_select {
    width: 150px;
  }

  .total-data {
    padding: 12px 10px;
    line-height: 18px;
  }

  .total-data-row {
    color: #444;
    padding-right: 30px;
    margin-right: 30px;
    border-right: 1px solid #CCC;
    font-family: Microsoft YaHei, arial;
    font-family: arial;
    font-size: 15px;
  }

  .total-data-row:last-child {
    border-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/finance/Order.vue